import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { removeOrAddToListByElement, removeFromListByIndex } from 'src/app/helpers/helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { Wrapper } from '../wrapper.component';
import { LabelType } from '../../services/ui.service';
import { ColorSelectorComponent } from '../branding/color-selector.component';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { DialogTitleComponent } from 'src/app/modules/program/dialog-title';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { Label } from 'globals/store/events.data';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'label-maker-dialog',
    template: `
<div class="label_maker_dialog joi-dialog small" [ngClass]="{ editing: mode === 'edit' }">
  <icon class="close" (click)="dialogRef.close()" matIcon="close"></icon>
  <dialog-title *ngIf="mode=='list'" [fontSize]="'14px'" [titleHeight]="'41px'" [title]="data.title || uiService.labelsByType[data.type].title + ' Labels'" [backgroundColor]="uiService.labelsByType[data.type].color" ></dialog-title>
    <div *ngIf="mode=='edit'">
        <icon class="back" (click)="mode='list'" matIcon="arrow_back"></icon>
        <dialog-title [fontSize]="'14px'" [titleHeight]="'41px'" [title]="'Edit ' + uiService.labelsByType[data.type].title + ' Label'" [backgroundColor]="uiService.labelsByType[data.type].color" ></dialog-title>
    </div>
    <div mat-dialog-content class="small">
      <ng-container *ngIf="mode=='list'">
          <div class="template_panel">
              <div *ngIf="!loading" class="label_list">
                  <div class="label_bar" *ngFor="let lbl of labelTemplate; index as idx">
                      <div class="bar" [ngStyle]="{background: lbl.color}" [ngClass]="{ uneditable: data.uneditable }" (click)="toggleMark(lbl.id)">
                          <icon class="lbl" matIcon="label"></icon>
                          <span class="label_text">{{lbl.label}}</span>
                          <span style="flex:1"></span>
                          <icon *ngIf="data.labels.includes(lbl.id)" icon="tick_24px"></icon>
                      </div>
                      <icon *ngIf="!data.uneditable" class="edit" (click)="editMode(lbl)" matIcon="edit"></icon>
                  </div>
                  <button *ngIf="!data.uneditable" mat-button class="plain" (click)="editMode()">+ Create a new label</button>
              </div>
          </div>
      </ng-container>
      <ng-container *ngIf="mode=='edit'">
          <div class="template_panel editing">
              <mat-form-field class="general">
                  <input matInput  #labelName name="title" [ngModel]="markedLabel.label" (ngModelChange)="labelNameChange($event)" placeholder="Label name">
              </mat-form-field>
              <div class="selector">
                <div class="label">Selected Color:</div>
                <color-selector class="choice" [tinyMode]="true" [color]="markedLabel.color" (changeColor)="changeColorOnly($event)"></color-selector>
                <div class="custom" (click)="colorSelector.pickerOpen = true">Custom</div>
              </div>
              
              <div class="label_group" style="margin-bottom: 18px">
                  <div class="tmpl" *ngFor="let tmpl of templateLabels; index as idx" [ngClass]="{last: idx%6==5, hide: idx>=6}"
                      [ngStyle]="{background: tmpl.color}" (click)="changeColor(tmpl)">
                      <icon *ngIf="tmpl.color==markedLabel.color" icon="tick_24px"></icon>
                  </div>
              </div>
              <div class="line"></div>
              <div class="label_group">
                  <div class="tmpl" *ngFor="let tmpl of templateLabels; index as idx" [ngClass]="{last: idx%6==5, hide: idx<6, row2: idx>11}"
                       [ngStyle]="{background: tmpl.color}" (click)="changeColor(tmpl)">
                      <icon *ngIf="tmpl.color==markedLabel.color" icon="tick_24px"></icon>
                  </div>
              </div>
          </div>
      </ng-container>
  </div>
  <div mat-dialog-actions *ngIf="mode=='edit'">
      <button mat-button class="delete" [autofocus]="false" *ngIf="markedLabel.id" (click)="deleteLabel($event)"><icon icon="delete_24px"></icon></button>
      <div style="flex-grow:1;"></div>
      <button mat-button color="primary" [autofocus]="false" [disabled]="!markedLabel.color" (click)="saveTemplateLabel()">SAVE LABEL</button>
  </div>
</div>
`,
    styleUrls: [`./label-marker.component.scss`],
    standalone: true,
    imports: [IconComponent, MatButtonModule, MatInputModule, CommonModule, MatFormFieldModule, FormsModule, DialogTitleComponent, ColorSelectorComponent]
})

export class LabelMakerDialogComponent extends Wrapper<LabelMakerDialogComponent> implements OnInit, OnDestroy {
  @ViewChild('labelMaker') labelMaker: ElementRef;
  @ViewChild('labelName') labelName: ElementRef;
  @ViewChild(ColorSelectorComponent) colorSelector: ColorSelectorComponent
  mode: 'list' | 'edit' = 'list';
  loading = true;
  markedLabel: Label = {} as Label;
  editingOldLabel = false
  templateLabels: Label[] = [];
  labelTemplate: Label[]
  labelUpdateFunction: LabelUpdateFunction
  positionTop = 0;
  positionLeft = 0;
  labelChanges = 0
  labelToggles = 0
  constructor(
    public dialogRef: MatDialogRef<LabelMakerDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: LabelMakerData,
  ) {
    super()
    this.labelUpdateFunction = this.data.labelUpdateFunction;
    this.data = jsonCopyObject(this.data);
  }

  ngOnInit() {
    this.templateLabels = jsonCopyObject(this.uiService.labelTemplate)
    this.labelTemplate = jsonCopyObject(this.data.labelTemplate)
    this.sortLabelTemplate()

    this.dialogRef.beforeClosed().subscribe(this.onClose.bind(this))
    this.initializePosition()
  }

  sortLabelTemplate() {
    this.labelTemplate.sort(this.uiService.sortLabels.bind(this.uiService))
  }

  onClose() {
    // console.log('CLOSING THE LABEL MAKER')
    this.labelUpdateFunction({
      labels: this.data.labels,
      labelTemplate:this.data.labelTemplate,
      labelsToggled: !!this.labelToggles,
      labelsChanged: !!this.labelChanges
    })
  }
  toggleMark(id) {
    removeOrAddToListByElement(this.data.labels, id)
    this.labelToggles++
  }

  async deleteLabel(evt) {
    const impact = this.data.type === 'event' ? 'globally' : 'in this event';

    const data: ConfirmDeleteData = { 
      rect: evt.target.getBoundingClientRect(), 
      title: 'Delete ' + this.data.type + ' label ' + impact, 
      para: 'All references to this ' + this.data.type + ' label will be deleted ' + impact,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    removeFromListByIndex(this.data.labelTemplate, this.data.labelTemplate.findIndex(lbl => lbl.id === this.markedLabel.id))
    removeFromListByIndex(this.labelTemplate, this.labelTemplate.findIndex(lbl => lbl.id === this.markedLabel.id))
    this.labelChanges++
    this.mode = 'list';
    this.markedLabel = {} as Label;
    this.editingOldLabel = true;

  }

  copyLabelData(label) {
    label.id = this.markedLabel.id;
    label.color = this.markedLabel.color;
    label.label = this.markedLabel.label;
    label.name = this.markedLabel.id.indexOf('custom') > -1 ? 'Custom label' : this.markedLabel.name || '';
  }

  saveTemplateLabel() {
    this.labelChanges++
    if (!this.markedLabel.label) {
      this.markedLabel.label = '';
    }
    if (this.editingOldLabel) { // already in list
      this.copyLabelData(this.data.labelTemplate.find(l => this.markedLabel.id === l.id))
      this.copyLabelData(this.labelTemplate.find(l => this.markedLabel.id === l.id))
      this.sortLabelTemplate()
    } else if (this.markedLabel.color) { // not sure why this is checking for color
      if (!this.markedLabel.id) {
        // const colorId = this.uiService.labelTemplate.find(tmpl => tmpl.color === this.markedLabel.color).id
        this.markedLabel.id = this.new_id(); // !this.data.labelTemplate.find(tmpl => tmpl.id === colorId) ? colorId : 
      }
      this.markedLabel.name = 'Custom label';
      this.data.labelTemplate.push(this.markedLabel);
      this.labelTemplate.push(this.markedLabel);
      this.sortLabelTemplate()
    }
    this.mode = 'list';
    this.markedLabel = {} as Label;
    this.editingOldLabel = false;
    setTimeout(() => this.rePosition(null), 10);
  }

  labelNameChange(labelName) {
    this.markedLabel.label = labelName;
    const labelEl = document.getElementsByClassName('label-panel');
    if (labelEl.length) {
      if (window.innerWidth <= 768) {
        labelEl[0]['style'].margin = 'auto';
      } else {
        if (window.innerHeight < this.positionTop + labelEl[0].clientHeight) {
          labelEl[0]['style'].marginTop = 'calc(100vh - ' + labelEl[0].clientHeight + 'px)';
        }
      }
    }
  }

  changeColor(tmpl) {
    this.markedLabel.color = tmpl.color;
    this.markedLabel.name = tmpl.name;
  }

  changeColorOnly(color: string) {
    if (!color) return
    this.markedLabel.color = color
  }

  editMode(lbl: Label | null = null) {
    this.mode = 'edit';
    this.markedLabel = lbl ? Object.assign({}, lbl) : { color: '#54DDC7' } as Label;
    this.editingOldLabel = lbl ? true : false
    setTimeout(_ => {
      this.labelName.nativeElement.focus();
      const labelEl = document.getElementsByClassName('label-panel');
      if (labelEl.length) {
        if (window.innerWidth <= 768) {
          labelEl[0]['style'].margin = 'auto';
        } else {
          if (window.innerHeight < this.positionTop + labelEl[0].clientHeight) {
            labelEl[0]['style'].marginTop = 'calc(100vh - ' + labelEl[0].clientHeight + 'px)';
          }
        }
      }
    }, 0);
  }

  private new_id() {
    return 'joi' + createId()/* SORRY, AESTHETICS this.data.labelTemplate
      .filter(tmpl => tmpl.id.includes('joi'))
      .map(tmpl=> parseInt(tmpl.id.replace('joi',''), 10) + 1)  
      .reduce((acc, idPlus) => idPlus > acc ? idPlus : acc, 1); */
  }

  private initializePosition() {
    setTimeout(_ => {
      this.loading = false
    }, 0);
    if (this.data.position) {
      this.positionTop = this.data.position.top;
      this.positionLeft = this.data.position.left;
      this.dialogRef.updatePosition({ top: this.data.position.top - 100 + 'px', left: this.data.position.left + 'px' })
      setTimeout(() => this.rePosition(null), 10);
    }
  }

  private rePosition(evt) {
    const labelEl = document.getElementsByClassName('label-panel');
    if (labelEl.length) {
      // const top = labelEl[0].getClientRects()[0].top;
      // console.log('(height, top): ', labelEl[0].clientHeight, +top, ', win ht: ', window.innerHeight);
      // console.log('dialog height: ', top + labelEl[0].clientHeight);
      if (window.innerWidth <= 768) {
        labelEl[0]['style'].margin = 'auto';
      } else {
        if (window.innerHeight <= this.positionTop + labelEl[0].clientHeight) {
          labelEl[0]['style'].marginTop = (document.body.clientHeight - labelEl[0].clientHeight) + 'px';
        } else {
          labelEl[0]['style'].marginTop = this.positionTop + 'px';
        }
      }
    }
  }
}


export interface LabelUpdateFunctionParams {
  labels: string[]
  labelTemplate: Label[]
  labelsToggled: boolean
  labelsChanged: boolean
}
export type LabelUpdateFunction = (params: LabelUpdateFunctionParams) => any

export interface LabelMakerData {
  offsetX?: number
  title?: string
  startTicked?: boolean
  uneditable?: boolean // unedible
  type: LabelType // label type
  labelTemplate: Label[] // (the actual labels)
  labels: string[] // (a list of select label ids)
  labelUpdateFunction: LabelUpdateFunction // must be specific to the type of labels called up
  position: {
    top: number
    left: number
  }
}